import React, { Component } from 'react';
import '../css/style.css';
import './Header.css';
import { NavDropdown, Nav, Navbar } from 'react-bootstrap';
import { translate } from "react-i18next";
import AuthenticationService from '../backend/AuthenticationService';
import i18n from "i18next";
import {USER_SESSION_ROLES} from '../backend/AuthenticationService';
import { getURL } from '../backend/Backend';
import { BLUE_BG, BLUE_BORDER} from '../backend/Colors';


class Header extends Component {

  constructor(props) {
    super(props);
    this.onSelectTab = this.onSelectTab.bind(this);
    
    this.state = { 
      user: this.props.user,
      roles:[],
      tabindex:0
     };
  }

  async componentDidMount() {
    let email = AuthenticationService.getLoggedInUserName();
    if(!email){
        return;
    }
    if (AuthenticationService.isUserLoggedIn()) {
      let roles = sessionStorage.getItem(USER_SESSION_ROLES);
      if(roles == null){
        let searchId=  '0';
        let searchEmail = AuthenticationService.getLoggedInUserName();
        const response = await fetch(getURL('users/search/' + searchId+'/'+searchEmail ))
       
        const user = await response.json();
        if(user){
          
          sessionStorage.setItem(USER_SESSION_ROLES, user.roles);
        } else{
          sessionStorage.setItem(USER_SESSION_ROLES, "");
        }
      }
    }
    let oldState = this.state;

    this.setState({ ...oldState,
        roles: sessionStorage.getItem(USER_SESSION_ROLES)
     });
  }


  onLogout() {
    AuthenticationService.logout();
    let oldState = this.state;
    this.setState({
      ...oldState,
      user: '',
      roles:[]
    })
  }

  onSelectTab(tabindex){
    let oldState = this.state;
    console.log("tabIndex:"+tabindex);
   this.setState({
      ...oldState,
      tabindex: tabindex
    });
  }

   
  render() {
    const { t } = this.props;
    let user = AuthenticationService.getLoggedUser();
    let lang = i18n.language;
    let bg = this.props.bg ? this.props.bg : BLUE_BG;
    let bgStrong = this.props.bgStrong ? this.props.bgStrong : BLUE_BORDER;
    let adminTool = this.state.roles.includes('ADMIN') ?(<div> 
      <NavDropdown.Item eventKey="de" href="#parameters" >AdminTool</NavDropdown.Item>
      <NavDropdown.Divider />
    </div>) : '' ;
    return (
          <div>
        
          <Navbar collapseOnSelect    style={{"backgroundColor":bg,  "position": "fixed", "width":"100%"}}  expand="lg"  >
          <Navbar.Brand href="/" ><span className="easy">easy</span><span className="event">Event</span></Navbar.Brand>
          <Navbar.Toggle aria-controls="responsive-navbar-nav" />
          <Navbar.Collapse id="responsive-navbar-nav">
            <Nav className="mr-auto">
              <NavDropdown title={t(lang)} id="collasible-nav-dropdown">
                {('de' !== lang ? (<NavDropdown.Item eventKey="de" onSelect={() => i18n.changeLanguage('de')}>{t("de")}</NavDropdown.Item>) : null)}
                {('fr' !== lang ? (<NavDropdown.Item eventKey="fr" onSelect={() => i18n.changeLanguage('fr')}>{t("fr")}</NavDropdown.Item>) : null)}
                {('en' !== lang ? (<NavDropdown.Item eventKey="en" onSelect={() => i18n.changeLanguage('en')}>{t("en")}</NavDropdown.Item>) : null)}
              </NavDropdown>
            </Nav>
            <Nav className="s16 align-middle">

              <Nav.Link href="#searchActivity"><span className="c-event"><i className="text-primary  ml-1  " >&nbsp;</i>{t("activities")}</span></Nav.Link>
              <Nav.Link href="#search"><span className="c-event"><i className="text-primary    mr-1  " >&nbsp;</i>{t("publicEvents")}</span></Nav.Link>
             
            
              {!AuthenticationService.isUserLoggedIn() ?
                <Nav.Link href="#loginPage/home" className="mr-2">

                  <span className="c-event ">
                     <i className="text-primary fa fa-user  ml-2 mr-1 " >&nbsp;</i>
                    {t("login")}</span>
                </Nav.Link>
                :
                <NavDropdown title={AuthenticationService.getLoggedInUserName()} id="collasible-nav-dropdown" className="mr-1 c-event " >
                  <NavDropdown.Item eventKey="de" href="#pwdChange" >{t("pwdChange")}</NavDropdown.Item>
                  <NavDropdown.Item eventKey="de" href="#profile" >{t("myProfil")}</NavDropdown.Item>
                  <NavDropdown.Divider />
                 {adminTool}
                
                 
                  <NavDropdown.Item eventKey="de" onSelect={() => this.onLogout()} >{t("logout")}</NavDropdown.Item>
                </NavDropdown>
              }


            </Nav>
          </Navbar.Collapse>
        </Navbar>
       
        </div>
 
    );
  }

}


export default translate("translations")(Header);